(() => {
  'use strict';
  const config = document.querySelector('[data-commerce-config]');
  if (!config) return;
  const root = config.dataset.root;
  const cart = document.getElementById('CartDrawer');
  const search = document.getElementById('SearchDialog');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let cartBusy = false;
  const closeMenu = () => document.querySelector('[data-menu-close]')?.click();
  const openDialog = (dialog) => {
    if (!dialog || !dialog.showModal) return false;
    closeMenu();
    if (!dialog.open) dialog.showModal();
    document.body.classList.add('dialog-open');
    return true;
  };
  document.querySelectorAll('dialog').forEach(dialog => {
    dialog.addEventListener('keydown', event => {
      if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); dialog.close(); }
    });
    dialog.addEventListener('close', () => {
      if (!document.querySelector('dialog[open]')) document.body.classList.remove('dialog-open');
    });
    dialog.addEventListener('click', event => {
      if (event.target.closest('[data-close-dialog]')) dialog.close();
      if (event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }
    });
  });
  document.querySelectorAll('[data-open-cart]').forEach(link => link.addEventListener('click', event => {
    if (openDialog(cart)) event.preventDefault();
  }));
  document.querySelectorAll('[data-open-search]').forEach(link => link.addEventListener('click', event => {
    if (openDialog(search)) { event.preventDefault(); search.querySelector('input[type=search]').focus(); }
  }));
  const collectionPage = document.querySelector('[data-collection-page]');
  const filterDialog = document.getElementById('CollectionFilters');
  if (collectionPage && filterDialog?.showModal) {
    const filterForm = collectionPage.querySelector('[data-filter-form]');
    const filterTrigger = collectionPage.querySelector('[data-open-filters]');
    filterDialog.append(filterForm);
    collectionPage.querySelector('[data-filter-fallback]').hidden = true;
    filterTrigger.hidden = false;
    filterTrigger.addEventListener('click', () => openDialog(filterDialog));
    // Unapplied edits must not silently carry into the next visit to the panel.
    filterDialog.addEventListener('close', () => filterForm.reset());
    filterForm.addEventListener('submit', () => {
      const submit = filterForm.querySelector('button[type=submit]');
      submit.textContent = 'Applying…';
      submit.disabled = true;
    });
    const gridToggle = collectionPage.querySelector('[data-grid-toggle]');
    const grid = collectionPage.querySelector('.collection-grid');
    if (grid) {
      gridToggle.hidden = false;
      const setGrid = large => {
        collectionPage.classList.toggle('large-product-view', large);
        gridToggle.setAttribute('aria-pressed', String(large));
        gridToggle.textContent = large ? 'More pieces' : 'Larger images';
        grid.querySelectorAll('.product-image-primary, .product-image-secondary').forEach(img => {
          img.sizes = large ? '(min-width: 990px) 50vw, 100vw' : '(min-width: 990px) 33vw, 50vw';
        });
      };
      try { setGrid(sessionStorage.getItem('dresscode-large-grid') === 'true'); } catch { /* Storage is optional. */ }
      gridToggle.addEventListener('click', () => {
        const large = gridToggle.getAttribute('aria-pressed') !== 'true';
        setGrid(large);
        try { sessionStorage.setItem('dresscode-large-grid', String(large)); } catch { /* Storage is optional. */ }
      });
    }
  }
  document.querySelector('[data-menu-close-top]')?.addEventListener('click', closeMenu);
  const menu = document.querySelector('[data-mobile-menu]');
  document.querySelector('[data-menu-toggle]')?.addEventListener('click', () => {
    if (!menu.hidden) menu.querySelector('button, a')?.focus();
  });
  menu?.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelector('[data-menu-toggle]')?.focus();
    if (event.key !== 'Tab') return;
    const focusable = [...menu.querySelectorAll('a, button')].filter(el => el.getClientRects().length);
    const first = focusable[0], last = focusable.at(-1);
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  const cartMessage = text => { cart.querySelector('[data-cart-feedback]').textContent = text; };
  async function replaceCart(markup) {
    if (!markup) {
      const response = await fetch(config.dataset.cartUrl + '?section_id=cart-drawer', { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Your bag could not be refreshed. Open View and edit bag to check it.');
      markup = await response.text();
    }
    const content = new DOMParser().parseFromString(markup, 'text/html').querySelector('[data-cart-content]');
    if (!content) throw new Error('Your bag could not be refreshed. Open View and edit bag to check it.');
    cart.querySelector('[data-cart-content]').replaceWith(content);
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = content.dataset.count; });
  }
  cart?.addEventListener('click', async event => {
    const button = event.target.closest('[data-cart-change]');
    if (!button || cartBusy) return;
    cartBusy = true;
    cart.setAttribute('aria-busy', 'true');
    cart.querySelectorAll('[data-cart-change], button[name=checkout]').forEach(el => { el.disabled = true; });
    cartMessage('Updating your bag…');
    try {
      const response = await fetch(root + 'cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: button.dataset.cartChange, quantity: Number(button.dataset.quantity), sections: ['cart-drawer'], sections_url: location.pathname })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to update this quantity.');
      await replaceCart(result.sections?.['cart-drawer']);
      cartMessage('Your bag is updated.');
      cart.querySelector('[data-cart-change], .solid-link')?.focus();
    } catch (error) {
      cartMessage(error.message || 'Please check your connection and try again.');
    } finally {
      cartBusy = false;
      cart.removeAttribute('aria-busy');
      cart.querySelectorAll('[data-cart-change], button[name=checkout]').forEach(el => { el.disabled = false; });
    }
  });

  document.querySelectorAll('[data-product-section]').forEach(section => {
    const select = section.querySelector('[data-variant-select]');
    const form = section.querySelector('[data-product-form]');
    const data = section.querySelector('[data-product-json]');
    if (!select || !form || !data) return;
    const variants = JSON.parse(data.textContent);
    const fields = [...section.querySelectorAll('.product-option')];
    const button = form.querySelector('[name=add]');
    const mobileButton = section.querySelector('[data-mobile-add]');
    const message = section.querySelector('[data-product-message]');
    const gallery = section.querySelector('[data-product-gallery]');
    let variant = variants.find(item => String(item.id) === select.value);
    let adding = false;
    section.classList.add('product-enhanced');
    const showMedia = id => {
      const item = [...gallery.querySelectorAll('[data-media-id]')].find(el => el.dataset.mediaId === String(id));
      if (item) gallery.scrollTo({ left: item.offsetLeft - gallery.offsetLeft, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
    };
    function update(fromOptions = false) {
      if (fromOptions) {
        const chosen = fields.map(field => field.querySelector('input:checked')?.value);
        variant = variants.find(item => item.options.every((value, index) => value === chosen[index]));
        select.value = variant ? String(variant.id) : '';
        const url = new URL(location.href);
        if (variant) url.searchParams.set('variant', variant.id); else url.searchParams.delete('variant');
        history.replaceState({}, '', url);
        if (variant?.featured_media?.id) showMedia(variant.featured_media.id);
      } else {
        variant = variants.find(item => String(item.id) === select.value);
        fields.forEach((field, index) => field.querySelectorAll('input').forEach(input => { input.checked = input.value === variant?.options[index]; }));
      }
      const label = variant ? (variant.available ? 'Add to bag' : 'Sold out') : 'Unavailable combination';
      [button, mobileButton].filter(Boolean).forEach(el => { el.disabled = adding || !variant?.available; el.textContent = label; });
      section.querySelector('[data-variant-status]').textContent = variant ? (variant.available ? 'Available to order' : 'This option is sold out') : 'Choose another combination.';
      const price = section.querySelector('[data-product-price]');
      const selectedOption = [...select.options].find(option => option.value === String(variant?.id));
      price.replaceChildren();
      if (selectedOption) {
        if (selectedOption.dataset.compare) { const oldPrice = document.createElement('s'); oldPrice.textContent = selectedOption.dataset.compare; price.append(oldPrice); }
        const currentPrice = document.createElement('span'); currentPrice.textContent = selectedOption.dataset.price; price.append(currentPrice);
      }
      section.querySelector('[data-mobile-variant]').textContent = variant ? variant.title.replace('Default Title', '') + ' · ' + selectedOption.dataset.price : 'Choose options';
      message.textContent = '';
      fields.forEach((field, index) => field.querySelectorAll('input').forEach(input => {
        const chosen = fields.map(f => f.querySelector('input:checked')?.value);
        const available = variants.some(item => item.available && item.options[index] === input.value && item.options.every((value, i) => i >= index || value === chosen[i]));
        input.nextElementSibling.classList.toggle('option-unavailable', !available);
        input.nextElementSibling.title = available ? '' : 'Unavailable with the preceding selection';
      }));
    }
    fields.forEach(field => field.addEventListener('change', () => update(true)));
    select.addEventListener('change', () => update(false));
    update();
    section.querySelectorAll('[data-gallery-target]').forEach(link => link.addEventListener('click', event => { event.preventDefault(); showMedia(link.dataset.galleryTarget); }));
    if ('IntersectionObserver' in window) {
      const images = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) section.querySelectorAll('[data-gallery-target]').forEach(link => {
          if (link.dataset.galleryTarget === entry.target.dataset.mediaId) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
      }), { root: gallery, threshold: .65 });
      gallery.querySelectorAll('[data-media-id]').forEach(el => images.observe(el));
      const sticky = section.querySelector('[data-mobile-product-action]');
      new IntersectionObserver(([entry]) => { sticky.hidden = entry.isIntersecting; }, { threshold: 0 }).observe(button);
    }
    gallery.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault(); gallery.scrollBy({ left: gallery.clientWidth * (event.key === 'ArrowRight' ? 1 : -1), behavior: reducedMotion.matches ? 'instant' : 'smooth' });
      }
    });
    form.addEventListener('submit', async event => {
      if (!cart || !window.fetch || !cart.showModal) return;
      event.preventDefault();
      if (adding || !variant?.available) return;
      adding = true;
      [button, mobileButton].filter(Boolean).forEach(el => { el.disabled = true; el.textContent = 'Adding…'; });
      message.textContent = '';
      let added = false;
      try {
        const formData = new FormData(form);
        formData.append('sections', 'cart-drawer');
        formData.append('sections_url', location.pathname);
        const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: formData });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'This piece could not be added.');
        added = true;
        await replaceCart(result.sections?.['cart-drawer']);
        cartMessage('Added to your bag.');
        openDialog(cart);
      } catch (error) {
        message.replaceChildren(document.createTextNode(added ? 'Added to your bag. ' : (error.message || 'Check your bag before trying again. ')));
        const link = document.createElement('a'); link.href = config.dataset.cartUrl; link.textContent = 'View your bag →'; message.append(link);
      } finally {
        adding = false;
        [button, mobileButton].filter(Boolean).forEach(el => { el.disabled = !variant?.available; el.textContent = variant?.available ? 'Add to bag' : 'Sold out'; });
      }
    });
  });
  document.querySelectorAll('[data-zoom-src]').forEach(button => button.addEventListener('click', () => {
    const lightbox = document.querySelector('.product-lightbox');
    const image = lightbox.querySelector('[data-zoom-image]');
    image.src = button.dataset.zoomSrc; image.alt = button.dataset.zoomAlt;
    openDialog(lightbox);
  }));
  const input = search?.querySelector('[data-instant-search]');
  const results = search?.querySelector('[data-search-results]');
  let timer, controller, searchSequence = 0;
  input?.addEventListener('input', () => {
    clearTimeout(timer); controller?.abort();
    const sequence = ++searchSequence;
    const query = input.value.trim();
    if (query.length < 2) { results.textContent = 'Enter at least two characters to find a piece.'; return; }
    results.textContent = 'Searching…';
    timer = setTimeout(async () => {
      controller = new AbortController();
      try {
        const url = new URL(config.dataset.predictiveUrl, location.origin);
        url.searchParams.set('q', query); url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '5'); url.searchParams.set('section_id', 'predictive-search');
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok) throw new Error('Search unavailable');
        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-predictive-results]');
        if (sequence !== searchSequence) return;
        if (parsed) results.replaceChildren(parsed); else results.textContent = 'Press Search to see all matching pieces.';
      } catch (error) {
        if (error.name !== 'AbortError' && sequence === searchSequence) results.textContent = 'Press Search to see all matching pieces.';
      }
    }, 220);
  });
  document.querySelectorAll('[data-recommendations]').forEach(async section => {
    try {
      const response = await fetch(section.dataset.url);
      if (!response.ok) return;
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-recommendations]');
      if (parsed && !parsed.hidden) { section.innerHTML = parsed.innerHTML; section.hidden = false; }
    } catch { /* Recommendations are optional; the product form stays usable. */ }
  });
})();
